import { Grid, IconButton, Paper } from '@material-ui/core';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import { sha256 } from 'js-sha256';
import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { PasswordBox } from '../../../components/PasswordBox';
import { useMessageBox } from '../../../context/MessageBox';
import Header from '../../../layout/Header';
import Subheader from '../../../layout/Subheader';
import api from '../../../services/api';
import { logout } from '../../../services/auth';
import { handleErrorRequest } from '../../../utils/errorsValidation';
import { Redirect, useHistory } from 'react-router';
import useStyles, * as S from './style';
import { useLoginPassword } from '../../../context/LoginPassword';
import { encrypt } from '../../../services/crypto';

export function RequiredChangePassword() {
  const location = useLocation();
  const history = useHistory();
  const { setExpiredLink, expiredLink } = useLoginPassword();

  const { setMessageData } = useMessageBox();

  const [getLoading, setLoading] = useState(false);
  const [isLoading, setisLoading] = useState();
  const [passwordRule, setPasswordRule] = useState();
  const [showPassword, setShowPassword] = useState(true);
  const [showConfirm, setShowConfirm] = useState(true);
  const [formValue, setFormValue] = useState({});
  const [open, setOpen] = useState(false);
  const [textOperatorBody, setTextOperatorBody] = useState('');

  const backLogin = () => {
    history.push('/app');
    setExpiredLink(true);
  };

  const onButtonClick = () => {
    const canRedirect = logout();
    if (canRedirect) {
      backLogin();
    }
  };

  const onSubmit = async (event) => {
    event.preventDefault();
    if (!formValue.senhaNova || !formValue.senhaNovaConfirmacao) {
      return toast.error('Preencha os campos de senha e confirmação de senha');
    }

    setisLoading(true);
    try {
      const response = await api.post(
        'Logins/TrocarSenha',
        {
          loginId: location?.state?.loginId,
          senhaAtual: '',
          senhaNova: encrypt(formValue?.senhaNova) || '',
          senhaNovaConfirmacao: encrypt(formValue?.senhaNovaConfirmacao) || '',
          obrigaTrocarSenha: 'sim',
        },
        {
          headers: { Authorization: `Bearer ${location?.state?.token}` },
        },
      );
      setMessageData(response?.data?.complemento?.mensagensBox);
      // setMessageType('CHANGE_PASSWORD');
      if (response.data.status !== 'Inconsistencia' && response.data.resposta?.processoConcluido) {
        toast.success('Cadastro de senha realizada com sucesso!');
        setTextOperatorBody(response.data.resposta?.mensagemOperador);
        setOpen(true);
        setFormValue({});
      } else {
        handleErrorRequest(response);
      }
    } catch (error) {
      console.log(error);
      handleErrorRequest(error);
    }
    setisLoading(false);
  };

  const passwordRules = async () => {
    try {
      const response = await api.get('Logins/RegrasSenha', {
        headers: { Authorization: `Bearer ${location?.state?.token}` },
      });
      if (response.data.status === 'Sucesso') {
        setPasswordRule(response.data?.resposta?.retornoString);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    passwordRules();
  }, [location?.state?.token]);

  if (expiredLink) {
    return <Redirect to="/app" />;
    // return (
    //   <S.Root>
    //     <Header hasMenuLinks={false} />
    //     <Subheader title="Cadastro de senha" onClickParam={backLogin} />

    //     <S.Content fullWidth={true}>
    //       <p style={{ textAlign: 'center' }}>
    //         Link expirado, <Link to="/app">clique aqui</Link> para fazer login novamente
    //       </p>
    //     </S.Content>
    //   </S.Root>
    // );
  }

  return (
    <S.Root>
      <Header hasMenuLinks={false} />
      <Subheader title="Cadastro de senha" onClickParam={backLogin} />

      <S.Content>
        <div className="message-html" dangerouslySetInnerHTML={{ __html: passwordRule }}></div>
        <S.PasswordBox>
          <Grid container spacing={2} className="container-password">
            <Grid item xs={12}>
              <S.InputLabel>Usuário</S.InputLabel>
              <Paper elevation={0} className="input-paper">
                <S.InputText
                  disabled
                  name="usuario"
                  placeholder="Usuário"
                  value={location?.state?.nome ?? ''}
                  inputProps={{
                    minLength: 3,
                    maxLength: 100,
                  }}
                />
              </Paper>
            </Grid>
            <Grid item xs={12}>
              <S.InputLabel>Login</S.InputLabel>
              <Paper elevation={0} className="input-paper">
                <S.InputText
                  disabled
                  value={location?.state?.login ?? ''}
                  placeholder="Login"
                  name="login"
                  inputProps={{
                    minLength: 3,
                    maxLength: 100,
                  }}
                />
              </Paper>
            </Grid>

            <Grid item xs={12}>
              <S.InputLabel>Nova senha</S.InputLabel>
              <div>
                <Paper elevation={0} className="input-paper">
                  <S.InputText
                    placeholder="Nova senha"
                    name="senhaNova"
                    autoFocus
                    value={formValue?.senhaNova}
                    onChange={(e) => setFormValue({ ...formValue, senhaNova: e.target.value })}
                    type={showPassword ? 'password' : 'text'}
                    inputProps={{
                      autoComplete: 'new-password',
                      minLength: 3,
                      maxLength: 100,
                    }}
                  />
                </Paper>
                <IconButton
                  className="icon-show"
                  onClick={() => setShowPassword(!showPassword)}
                  tabindex="-1"
                >
                  {showPassword ? <Visibility /> : <VisibilityOff />}
                </IconButton>
              </div>
            </Grid>

            <Grid item xs={12}>
              <S.InputLabel>Confirmação nova senha</S.InputLabel>
              <div>
                <Paper elevation={0} className="input-paper">
                  <S.InputText
                    value={formValue?.senhaNovaConfirmacao}
                    onChange={(e) =>
                      setFormValue({ ...formValue, senhaNovaConfirmacao: e.target.value })
                    }
                    placeholder="Confirmação nova senha"
                    type={showConfirm ? 'password' : 'text'}
                    inputProps={{
                      autoComplete: 'new-password',
                      minLength: 3,
                      maxLength: 100,
                    }}
                  />
                </Paper>
                <IconButton
                  className="icon-show"
                  onClick={() => setShowConfirm(!showConfirm)}
                  tabindex="-1"
                >
                  {showConfirm ? <Visibility /> : <VisibilityOff />}
                </IconButton>
              </div>
            </Grid>

            <S.ActionFooter>
              <S.ActionButton variant="contained" disabled={isLoading} onClick={onSubmit}>
                {isLoading ? 'Confirmando...' : 'Confirmar'}
              </S.ActionButton>
            </S.ActionFooter>
          </Grid>
        </S.PasswordBox>
      </S.Content>
      <PasswordBox callback={onButtonClick} open={open} textBody={textOperatorBody} />
    </S.Root>
  );
}
